module.exports = __webpack_public_path__ + "img/logo.ab6b6cda.png";